<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoEditar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso a essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoEditar">
			<form #f="ngForm" name="form" novalidate>
				<div class="formgroup" >
					<div class="flex justify-content-center" *ngIf="loading">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="w-full mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					
					<div class="p-fluid p-formgrid grid" *ngIf="planoContaEmpresa && !loading">
						
						<div class="form-group field col-12 md:col-5">
							<label>Descrição da Conta</label>
							<label class="form-control">{{ planoContaEmpresa.descricao }}</label>
						</div>
						<div class="form-group field col-12 md:col-7">
							<label>Especificação</label>
							<label class="form-control">{{ planoContaEmpresa.especificacao }}</label>
						</div>
						<div class="form-group field col-12 md:col-3">
							<label>DRE</label>
							<label class="form-control">{{ planoContaEmpresa.dre }}</label>
						</div>
						<div class="form-group field col-12 md:col-4">
							<label>Grupo</label>
							<label class="form-control">{{ planoContaEmpresa.planoContaGrupo?.descricao }}</label>
						</div>
						<div class="field col-12 md:col-3" *ngIf="planoContaEmpresa.planoContaGrupo?.descricao === 'CUSTO PESSOAL'">
							<label htmlFor="utilizacao">Utilização</label>
							<p-dropdown [options]="utilizacoes"
								placeholder="Selecione" name="utilizacao" ngModel #utilizacao="ngModel"
								[(ngModel)]="planoContaEmpresa.utilizacao">
							</p-dropdown>
						</div>
						<div class="form-group field col-12 md:col-2">
							<label>Referência Folha</label>
							<label class="form-control">{{ planoContaEmpresa.referenciaFolha }}</label>
						</div>
						<div class="form-group field col-12 md:col-3">
							<label>Patrimonial</label>
							<label class="form-control">{{ planoContaEmpresa.patrimonial }}</label>
						</div>
						<div class="field col-12 md:col-1">
							<label for="ativo">Ativo?</label>
							<br/>
							<p-inputSwitch  name="ativo" [(ngModel)]="planoContaEmpresa.ativo"></p-inputSwitch>
						</div>
					</div>
					<div class="p-fluid p-formgrid grid justify-content-between" *ngIf="!loading">
						<div class="field col-12 md:col-4" >
							<button *ngIf="!progressoRequisicao else exibirBotaoFalso"
								type="button" pButton icon="pi pi-check" label="Atualizar"
								class="p-button-outlined p-button-success md:w-9rem" [disabled]="!f.valid" (click)="atualizar()">
							</button>
							<ng-template #exibirBotaoFalso>
								<button type="button" pButton icon="pi pi-spin pi-spinner" label="Atualizar"
								class="p-button-outlined p-button-success md:w-9rem" disabled>
								</button>
							</ng-template>
						</div>
						<div class="field col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/plano-conta-empresa"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>